import React from 'react';


const Label = React.forwardRef((props, ref) => {
    return (
        <label className="form-label" ref={ref}  {...props}/>
    );
});

export default Label;